import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import './multiselect.scss'

Vue.component('multiselect', Multiselect)



// WEBPACK FOOTER //
// ./src/components/Plugins/Multiselect/Multiselect.js